import React, { useState, useEffect, useRef } from 'react'
import './SearchBoxEncounter.scss'
import { CCol, CRow } from '@coreui/react-pro'
import PropTypes from 'prop-types'

const SearchBoxEncounter = ({ placeholder, searchText, setSearchText, shouldFocus }) => {
  const [isContent, setIsContent] = useState(false)
  const [isFocus, setIsFocus] = useState(false)

  const focusRef = useRef(null)
  useEffect(() => {
    if (shouldFocus && focusRef.current) {
      // timeout because they way CoreUI handles modals,
      // there is a delay in mounting the input
      setTimeout(() => {
        focusRef.current?.focus()
      }, 1000)
    }
  }, [shouldFocus])

  const handleChangeSearch = (text) => {
    setIsContent(text !== '')
    setSearchText(text)
  }

  const handleCloseClick = () => {
    setIsContent(false)
    setSearchText('')
  }

  return (
    <div
      className={`search-container searchbox-container-practice searchbox-bg-practice searchbox-${
        isFocus ? 'focus' : 'normal'
      }-practice`}
    >
      <CRow className="search-holder">
        <CCol xs={12} className="searchCol">
          <div className={'input-holder'}>
            <input
              ref={focusRef}
              type="text"
              className="input-search"
              placeholder={placeholder || 'Search by code or description...'}
              onBlur={() => setIsFocus(false)}
              onFocus={() => setIsFocus(true)}
              onChange={(e) => handleChangeSearch(e.target?.value)}
              value={searchText}
            />
            {isContent ? (
              <div className="close-icon-container-practice">
                <i
                  className="far fa-xmark"
                  style={{ fontSize: '1.1em', cursor: 'pointer' }}
                  onClick={handleCloseClick}
                ></i>
              </div>
            ) : (
              <i
                className="fa-sharp fa-magnifying-glass icon-search-encounter"
                style={{ fontSize: '0.85em', marginTop: '5px' }}
              ></i>
            )}
          </div>
        </CCol>
      </CRow>
    </div>
  )
}
SearchBoxEncounter.propTypes = {
  placeholder: PropTypes.string,
  searchText: PropTypes.string,
  setSearchText: PropTypes.func,
  shouldFocus: PropTypes.bool,
}

export default SearchBoxEncounter
